<template>
  <div>
    <b-form
      novalidate
      @submit.stop.prevent
    >
      <b-table
        id="surveymemberstable"
        hover
        fixed
        :fields="fields"
        :items="groupsurveymembers"
        :per-page="perPage"
        :current-page="currentPage"
      >
        <template v-slot:head(select)>
          <b-form-checkbox
            v-model="selected"
            @click.native.stop
            @change="selectall(selected)"
          />
        </template>
        <template v-slot:cell(select)="data">
          <div style="padding-top: 4px;height: 36px; vertical-align: middle !important;">
            <b-form-checkbox
              v-if="data.item.included_in_survey == 1"
              v-model="data.item.selected"
              @input="countselected"
            />
          </div>
        </template>
        <template v-slot:cell(groupsurveymember_survey_code)="data">
          <div style="padding-top: 4px;height: 36px; vertical-align: middle !important">
            <b-button
              v-if="data.item.included_in_survey == 1"
              :disabled="survey.survey_status_id > 3"
              variant="outline-light"
              class="text-danger outline-light btn btn-small my-0 py-0 px-1"
              @click.prevent="if (mode == 'edit') { excludegroupmemberprompt(data.item.id) }"
            >
              x
            </b-button>
            <b-button
              v-if="data.item.included_in_survey == 0"
              :disabled="survey.survey_status_id > 3"
              variant="outline-light"
              class="text-success outline-light btn btn-small my-0 py-0 px-1"
              @click.prevent="if (mode == 'edit') { togglegroupmember(data.item.id) }"
            >
              +
            </b-button>
            <span
              class="mr-1"
              @click.prevent="if (mode == 'edit') { if (data.item.included_in_survey == 1) { excludegroupmemberprompt(data.item.id) } else { togglegroupmember(data.item.id) }}"
            >
              <span
                v-show="data.item.included_in_survey == 0"
                style="position:absolute;z-index: 1"
                class="icon-cancel text-danger h4"
              >&nbsp;</span>
              <fa-icon
                name="user"
                class="ml-1"
              />
            </span>
            <span
              style="height: 36px;position: absolute; top: 0px;"
              class="d-none d-sm-inline pt-3"
              :class="data.item.displayclass"
            >{{ data.item.groupsurveymember_survey_code }}</span>
          </div>
        </template>
        <template v-slot:cell(groupmember_email)="data">
          <b-form-input
            :class="`${data.item.displayClass} ${anon ? 'g-anon' : '' }`"
            v-if="mode == 'edit' && survey.survey_status_id < 4 && data.item.groupsurveymember_formoption_id == 1"
            v-model="data.item.groupmember_email"
            type="text"
            @change="setformchanged"
          />
          <div
            v-if="mode != 'edit' && data.item.groupsurveymember_formoption_id == 1"
            style="padding-top: 4px;height: 36px; vertical-align: middle !important"
          >
            <span
              :class="`${data.item.displayClass} ${anon ? 'g-anon': '' }`"
            >{{ data.item.groupmember_email }}</span>
          </div>
          <div
            v-if="mode == 'edit' && survey.survey_status_id > 3 && data.item.groupsurveymember_formoption_id == 1"
          >
            <span
              :class="data.item.displayClass"
            >{{ data.item.groupmember_email }}</span>
          </div>
        </template>
        <!-- <template v-slot:cell(groupmember_name)="data">
          <b-form-input
            v-if="mode == 'edit'"
            v-model="data.item.groupmember_name"
            :class="data.item.displayclass"
            type="text"
            @change="setformchanged"
          />
          <span
            v-if="mode != 'edit'"
            :class="data.item.displayClass"
          >{{ data.item.groupmember_name }}</span>
        </template> -->
        <template v-slot:cell(groupmember_mobile)="data">
          <b-form-input
            v-if="mode == 'edit'"
            v-model="data.item.groupmember_mobile"
            :class="data.item.displayclass"
            @change="setformchanged"
          />
          <span
            v-if="mode != 'edit'"
            :class="data.item.displayClass"
          >{{ data.item.groupmember_mobile }}</span>
        </template>
        <template v-slot:cell(groupsurveymember_formoption_id)="data">
          <b-form-select
            v-if="data.item.groupsurveymember_status_id < 2 && mode == 'edit'"
            v-model="data.item.groupsurveymember_formoption_id"
            :class="data.item.displayclass"
            :options="formoptions"
            @change="setformchanged"
          />
          <div
            v-if="data.item.groupsurveymember_status_id > 1 || mode != 'edit'"
            class="pt-2 pl-3"
            :class="data.item.displayclass"
            style="height: 36px;"
          >
            {{ data.item.groupsurveymember_formoption_name }}
          </div>
        </template>
        <template
          v-slot:cell(groupsurveymember_status_id)="data"
          class="small"
        >
          <div
            v-show="data.item.included_in_survey == 1"
          >
            <div
              v-if="data.item.groupsurveymember_status_id == 1"
              style="height: 36px; border-radius: 6px;"
              class="bg-danger text-center col-12 small pt-2"
            >
              <span
                class="d-inline d-sm-none"
                :class="data.item.displayclass"
              >{{ data.item.groupsurveymember_survey_code }}</span>
              <span class="d-none d-md-inline">
                {{ (resp.data.result[i].invoice_id || 0) > 0 ? '*' : ''  }}
                <span v-if="data.item.groupsurveymember_formoption_id==1">Not sent</span>
                <span v-if="data.item.groupsurveymember_formoption_id==2">Not printed</span>
                <span v-if="data.item.groupsurveymember_formoption_id==3">Manual send</span>
              </span>
            </div>
            <div
              v-if="data.item.groupsurveymember_status_id == 2"
              style="height: 36px; border-radius: 6px;"
              class="bg-warning text-center col-12 small pt-2"
            >
              <span
                class="d-inline d-sm-none"
                :class="data.item.displayclass"
              >{{ data.item.groupsurveymember_survey_code }}</span>
              <span class="d-none d-md-inline">
                <span v-if="data.item.groupsurveymember_formoption_id==1">Sent</span>
                <span v-if="data.item.groupsurveymember_formoption_id==2">Printed</span>
                <span v-if="data.item.groupsurveymember_formoption_id==2">Manual send</span>
              </span>
            </div>
            <div
              v-if="data.item.groupsurveymember_status_id == 3"
              style="height: 36px; border-radius: 6px;"
              class="bg-secondary text-center col-12 small pt-2"
            >
              <span
                class="d-inline d-sm-none"
                :class="data.item.displayclass"
              >{{ data.item.groupsurveymember_survey_code }}</span>
              <span class="d-none d-md-inline">Started (<span class="d-none d-xl-inline">{{ data.item.gdq_answers }})</span></span>
            </div>
            <div
              v-if="data.item.groupsurveymember_status_id == 4"
              style="height: 36px; border-radius: 6px;color: white;"
              class="bg-primary text-center col-12 small pt-2"
            >
              <span
                class="d-inline d-sm-none"
                :class="data.item.displayclass"
              >{{ data.item.groupsurveymember_survey_code }}</span>
              <span class="d-none d-md-inline">Completed (<span class="d-none d-xl-inline">{{ data.item.gdq_answers }})</span></span>
            </div>
          </div>
          <div v-show="data.item.included_in_survey == 0">
            <div
              style="height: 36px; border-radius: 6px;"
              class="text-muted text-center col-12 small pt-2"
            >
              <span class="d-none d--inline">Not participating</span>
            </div>
          </div>
        </template>
        <template v-slot:cell(actions)="data">
          <div
            v-if="data.item.groupsurveymember_formoption_id!=2"
            class="pt-0"
            @click.prevent="getlink(data.item.id)"
          >
            <fa-icon
              name="link"
              class="ml-1"
            />
          </div>
          <div
            v-if="data.item.groupsurveymember_formoption_id==2 && data.item.groupsurveymember_status_id < 4"
            class="pt-0"
          >
            <span
              v-if="data.item.groupsurveymember_status_id < 4"
              class="icon-edit mr-4 d-none d-lg-inline"
              @click.prevent="openquestionnaire(data.item.id)"
            />
            <span
              class="icon-printer d-none d-lg-inline"
              @click.prevent="printform(data.item.id)"
            />
          </div>
        </template>
      </b-table>
      <b-row class="pb-4 mx-auto">
      <!-- b-pagination
        class="mx-auto"
        v-show="rows > perPage"
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="surveymemberstable"
      >
      </b-pagination -->
      </b-row>
    </b-form>
    <b-row
      v-show="formchanged == true && addingsurveymember == false"
      class="pb-4"
    >
      <div class="col-12 mx-auto text-center">
        <span class="pb-4">You have made changes to the Survey Members, what do you want to do?</span><br><br><b-button
          class="btn-lg mr-4"
          variant="primary"
          @click.prevent="saveform"
        >
          Save Changes
        </b-button>
        <b-button
          class="btn-lg"
          variant="danger"
          @click.prevent="clearform"
        >
          Cancel Changes
        </b-button>
      </div>
    </b-row>
    <b-modal
      id="memberlink"
      class="col-12 col-lg-6"
      title="Questionnaire link"
    >
      <b-input-group>
        <b-form-input
          ref="currentlink"
          v-model="currentlink"
          label="Link"
          readonly
        />
      </b-input-group>
      <br>
      <b-form-input
        ref="currentcode"
        v-model="currentcode"
        readonly
      />
      <br>
      <b-form-textarea
        v-model="currentcodelink"
        rows="6"
        readonly
      />
    </b-modal>
    <b-modal
      v-model="displayexcludewarning"
      hide-footer
      title="Exclude group member from survey?"
    >
      <div
        v-if="displayexcludeanswers==true"
        class="error"
      >
        This member has replied to the survey, all replies from this member will be deleted and cannot be retrieved again
      </div>
      <div
        v-if="displayexcludeanswers==false"
        class="success"
      >
        This member has not replied to the survey
      </div>
      <b-button
        class="mt-3"
        variant="danger"
        block
        @click="excludegroupmember"
      >
        Yes, delete
      </b-button>
      <b-button
        class="mt-2"
        variant="secondary"
        block
        @click="excludegroupmembercancel"
      >
        Cancel
      </b-button>
    </b-modal>
  </div>
</template>
<script>
import { config } from '../../config'
export default {
  name: 'GroupSurveyMembers',
  components: {

  },
  props: {
    mode: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      perPage: 999,
      currentPage: 1,
      fields: [
        { key: 'select', label: 'S', sortable: false, tdClass: 'gdq-w-15 mr-2 pr-2', thClass: 'gdq-w-15 mr-2 pr-2' },
        { key: 'groupsurveymember_survey_code', label: 'Code', sortable: true, tdClass: 'col', thClass: 'col' },
        { key: 'groupmember_email', label: 'Email', sortable: true, tdClass: 'd-none d-sm-table-cell col', thClass: 'd-none d-sm-table-cell col' },
        // { key: 'groupmember_name', label: 'Name', sortable: true, tdClass: 'd-none d-lg-table-cell col',thClass: 'd-none d-lg-table-cell col' },
        { key: 'groupmember_mobile', label: 'Mobile', sortable: true, tdClass: 'd-none', thClass: 'd-none' },
        { key: 'groupsurveymember_formoption_id', label: 'Form type', sortable: false, tdClass: 'd-none d-lg-table-cell col', thClass: 'd-none d-lg-table-cell col' },
        { key: 'groupsurveymember_status_id', label: 'Status', sortable: true, tdClass: 'col', thClass: 'col' },
        { key: 'actions', label: '', sortable: false, tdClass: 'gdq-w-20 col', thClass: 'gdq-w-20 col' }
      ],
      groupsurveymembers: [],
      formchanged: false,
      selected: 0,
      membersselected: 0,
      currentcode: '',
      currentlink: '',
      displayexcludewarning: false,
      displayexcludeanswers: false,
      removingmemberid: 0
    }
  },
  computed: {
    anon: function () {
      return this.$store.state.anon
    },
    currentcodelink: function () {
      return this.currentlink + '\n\n' + this.currentcode
    },
    surveymembers_reload: function () {
      return this.$store.state.surveymembers_reload
    },
    questionnaire_admin_done: function () {
      return this.$store.state.questionnaire_admin_done
    },
    survey: function () {
      return this.$store.state.currentsurvey
    },
    rows: {
      get () {
        return this.groupsurveymembers.length
      },
      set () {
        return true
      }
    },
    formoptions: {
      get () {
        var items = this.$store.state.formoptions
        var formoptions = []
        for (var i = 0; i < items.length; i++) {
          var option = {
            value: items[i].id,
            text: items[i].formoption_name
          }
          formoptions.push(option)
        }
        return formoptions
      }
    },
    addingsurveymember: {
      get () {
        return this.$store.state.addingsurveymember
      },
      set () {
        return true
      }
    }
  },
  watch: {
    surveymembers_reload: function () {
      this.surveymembers_get()
    },
    questionnaire_admin_done: function () {
      this.surveymembers_get()
    },
    addingsurveymember: function () {
      if (this.addingsurveymember == false) {
        this.surveymembers_get()
      }
    }
  },
  created () {
    this.formoptions_get()
    this.surveymembers_get()
    this.$store.dispatch('groupsurveymembers_setselected', { surveymembers: [] })
    this.$store.dispatch('questionnaire_setadmin', { admin: false })
    this.$store.dispatch('questionnaire_setadmin_code', { code: '' })
    this.$store.dispatch('questionnaire_setadmin_done', { done: false })
    this.$store.dispatch('questionnaire_gdqquestionanswers_clear', {})
  },
  methods: {
    parse_email (email) {
      // eslint-disable-next-line
      const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;   
      return pattern.test(email.toLowerCase())
    },
    getlink (id) {
      this.$store.dispatch('groupsurveymember_fetch', { id: id })
        .then(resp => {
          const link = config.front_url + '/gdqquestionnaire/' + resp.data.groupsurveymember_token
          this.currentlink = link
          this.currentcode = resp.data.groupsurveymember_survey_code
          this.$bvModal.show('memberlink')
        })
    },
    printform (id) {
      this.$store.dispatch('paperform_fetch', { surveymember_id: id })
        .then((resp) => {
          var paperformsurl = config.report_url + '/gdq_paperforms.php?i=' + resp.data.id
          window.open(paperformsurl)
        })
    },
    openquestionnaire (id) {
      this.$store.dispatch('groupsurveymember_fetch', { id: id })
        .then((resp) => {
          var token = resp.data.groupsurveymember_token
          var code = resp.data.groupsurveymember_survey_code
          this.$store.dispatch('questionnaire_setadmin', { admin: true })
            .then(() => {
              this.$store.dispatch('questionnaire_setadmin_code', { code: code })
                .then(() => {
                  window.open('/gdqquestionnaire/' + token)
                })
            })
        })
    },
    selectall (selected) {
      var setselectto = !selected
      for (var i = 0; i < this.groupsurveymembers.length; i++) {
        if (this.groupsurveymembers[i].included_in_survey == 1) {
          this.groupsurveymembers[i].selected = setselectto
        }
      }
      this.countselected()
    },
    countselected () {
      var selectedsurveymembers = []
      var numbersel = 0
      for (var i = 0; i < this.groupsurveymembers.length; i++) {
        if (this.groupsurveymembers[i].included_in_survey == 1) {
          if (this.groupsurveymembers[i].selected) {
            selectedsurveymembers.push(this.groupsurveymembers[i].id)
            numbersel++
          }
        }
      }
      this.membersselected = numbersel
      this.$store.dispatch('groupsurveymembers_setselected', { surveymembers: selectedsurveymembers })
    },
    excludegroupmemberprompt (id) {
      this.removingmemberid = id
      this.$store.dispatch('questionnaire_gdqquestionanswers_fetch', { surveymember_id: id })
        .then((resp) => {
          if (resp.length > 0) {
            this.displayexcludeanswers = true
          } else {
            this.displayexcludeanswers = false
          }
          this.displayexcludewarning = true
        })
    },
    // Delete all answers and set member to excluded AND status 1 (not sent/printed)
    excludegroupmember () {
      this.$store.dispatch('groupsurveymember_remove', { id: this.removingmemberid })
        .then(() => {
          this.removingmemberid = 0
          this.displayexcludewarning = false
          this.surveymembers_get()
        })
    },
    excludegroupmembercancel () {
      this.displayexcludewarning = false
    },
    togglegroupmember (id) {
      this.formchanged = false
      var changeindex = 0
      for (var i = 0; i < this.groupsurveymembers.length; i++) {
        if (this.groupsurveymembers[i].id == id) {
          changeindex = i
        }
      }
      if (this.groupsurveymembers[changeindex].groupsurveymember_status_id < 4) {
        if (this.groupsurveymembers[changeindex].included_in_survey == 1) {
          this.groupsurveymembers[changeindex].included_in_survey = 0
        } else {
          this.groupsurveymembers[changeindex].included_in_survey = 1
        }
      }
      this.saveform()
    },
    clearform () {
      this.formchanged = false
      this.surveymembers_get()
    },
    saveform () {
      this.formchanged = false
      var savemembers = []
      for (var i = 0; i < this.groupsurveymembers.length; i++) {
        var member = {
          newid: this.groupsurveymembers[i].id,
          id: this.groupsurveymembers[i].groupmember_id,
          groupmember_email: this.groupsurveymembers[i].groupmember_email,
          groupmember_name: this.groupsurveymembers[i].groupmember_name,
          groupmember_mobile: this.groupsurveymembers[i].groupmember_mobile,
          groupsurveymember_formoption_id: this.groupsurveymembers[i].groupsurveymember_formoption_id,
          included_in_survey: this.groupsurveymembers[i].included_in_survey
        }
        savemembers.push(member)
      }
      var data = {
        group_id: this.$store.state.currentgroup_id,
        survey_id: this.$store.state.currentsurvey_id,
        groupmembers: savemembers,
        group: this.$store.state.currentgroup,
        survey: this.$store.state.currentsurvey
      }
      this.$store.dispatch('groupsurveymembers_create', data)
        .then(() => {
          this.surveymembers_get()
        })
    },
    setformchanged () {
      this.formchanged = true
      this.addingsurveymember = false
      this.saveform()
    },
    formoptions_get: function () {
      this.$store.dispatch('formoptions_fetch')
    },
    surveymembers_get () {
      this.$store.dispatch('groupsurveyandgroupmembers_fetch', { survey_id: this.$store.state.currentsurvey.id })
        .then((resp) => {
          var groupsurveymembers = new Array()
          for (var i = 0; i < resp.data.result.length; i++) {
            var groupsurveymember_formoption_id = resp.data.result[i].groupsurveymember_formoption_id
            var groupsurveymember_formoption_name = 'None'
            for (var j = 0; j < this.formoptions.length; j++) {
              if (resp.data.result[i].groupsurveymember_formoption_id == this.formoptions[j].value) {
                groupsurveymember_formoption_name = this.formoptions[j].text
              }
            }
            var displayclass = ''
            if (resp.data.result[i].included_in_survey == 0) {
              displayclass = 'text-muted'
            }
            const member = {
              id: resp.data.result[i].id,
              groupmember_id: resp.data.result[i].groupmember_id,
              groupsurveymember_survey_code: resp.data.result[i].groupsurveymember_survey_code,
              groupmember_name: resp.data.result[i].groupmember_name,
              groupmember_email: resp.data.result[i].groupmember_email,
              groupmember_mobile: resp.data.result[i].groupmember_mobile,
              groupsurveymember_formoption_id: groupsurveymember_formoption_id,
              groupsurveymember_formoption_name: groupsurveymember_formoption_name,
              groupsurveymember_status_id: resp.data.result[i].groupsurveymember_status_id,
              invoice_id: resp.data.result[i].invoice_id,
              gdq_answers: resp.data.result[i].gdq_answers,
              displayclass: displayclass,
              included_in_survey: resp.data.result[i].included_in_survey,
              selected: 0
            }

            groupsurveymembers.push(member)
          }
          console.log({ groupsurveymembers })
          this.groupsurveymembers = groupsurveymembers
        })
    }
  }
}
</script>
<style>
</style>
